// 1. Initialize Shopify Object
window.Shopify = window.Shopify || {};
window.Shopify.getCart = window.Shopify.getCart || function(callback, cart) {
  if (!cart) {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        if (typeof callback === 'function') callback(data);
        else if (typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(data);
      })
      .catch(err => console.error('Error fetching cart:', err));
  } else {
    if (typeof callback === 'function') callback(cart);
    else if (typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate(cart);
  }
};

// 2. Global Variables & Cached Selectors
const productVariants = window.productVariants || [];
const productOptions = window.productOptions || [];
const variantRadioButtons = document.querySelectorAll('.variant-radio');
const variantSelects = document.querySelectorAll('.variant-option');
const cartSection = document.querySelector('.drawer .js-contents');

const cachedUI = {
  initialized: false,
  form: null,
  hiddenInput: null,
  quantityInput: null,
  newPrice: null,
  centPrice: null,
  oldPrice: null,
  percentOff: [],
  addButton: null,
  afterpay: null,
  priceDiff: null,
  colorName: null
};

// 3. Helper Functions
function findSelectedVariant(variants, selectedValues) {
  const selectedValuesString = selectedValues.join(',');
  return variants.find(variant => variant.options.join(',') === selectedValuesString);
}

function hideCompareAtPriceElement(selectedVariant) {
  const productAction = document.querySelector('.product-action');
  if (!productAction) return;
  
  if (selectedVariant.compare_at_price <= 0) {
    productAction.classList.add('hide_compare_at');
  } else {
    productAction.classList.remove('hide_compare_at');
  }
}

function addToCartButton($addButton, $addButtonStatus, selectedVariant) {
  if (!$addButton) return;
  const state = getVariantAvailabilityState(selectedVariant); // Assuming this is defined elsewhere
  const span = $addButton.querySelector('span');

  if (!$addButtonStatus || state === 2) {
    $addButton.disabled = true;
    $addButton.classList.add('disabled');
    $addButton.classList.remove('preorder');
    if (span) span.innerHTML = "Sold Out";
    return;
  }

  $addButton.disabled = false;
  $addButton.classList.remove('disabled');

  switch (state) {
    case 1:
    case 4:
      $addButton.classList.remove('preorder');
      if (span) span.innerHTML = "Add to Cart";
      break;
    case 3:
      $addButton.classList.add('preorder');
      if (span) span.innerHTML = "Pre Order";
      break;
  }
}

// Sets ?variant= and keeps everything else in the address (view, utm_* tags, click ids, the hash),
// so a reload, Back or a shared link keeps the template and the campaign tags. It still calls
// replaceState every time, which update-product-ui.js listens for.
function updateURL(selectedVariant) {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', selectedVariant.id);
  window.history.replaceState(null, null, url);
}

function updateHiddenInput(selectedVariant, $hiddenInput) {
  if ($hiddenInput) $hiddenInput.value = selectedVariant.id;
  const updateButtonFrom = document.querySelector('form.buttonproduct input.product-variant-id');
  if (updateButtonFrom) updateButtonFrom.value = selectedVariant.id;
}

function setQuantityInputValue(selectedVariant, $quantityInput) {
  if (!$quantityInput) return;
  $quantityInput.value = 1;
  let setUpdatedQuantity = selectedVariant.inventory_quantity;
  if (setUpdatedQuantity <= 0 && selectedVariant.inventory_policy === 'continue') {
    setUpdatedQuantity = 12;
  }
  $quantityInput.setAttribute("max", setUpdatedQuantity);
}

function updateMedia(selectedVariant) {
  if (!selectedVariant?.featured_media) return;
  const current_media_id = selectedVariant.featured_media.id;

  const imageSlider = document.querySelector('.product__image-slider');
  const imageSliderInstance = imageSlider && (
    window.flkty ||
    (window.Flickity ? window.Flickity.data(imageSlider) : null)
  );

  if (imageSliderInstance) {
    // Match by slide, not by picture: a video slide holds no <img>, so counting pictures
    // would land on the wrong slide for any image after a video
    const slides = Array.from(imageSlider.querySelectorAll('.carousel-cell'));
    const index = slides.findIndex(slide => slide.querySelector(`[data-media-id="${current_media_id}"]`));
    if (index !== -1) imageSliderInstance.select(index);
  } else {
    const mediaList = document.querySelector('.product__media-list');
    if (mediaList) {
      Array.from(mediaList.children).forEach(child => {
        child.style.display = child.getAttribute('data-media-id').includes(current_media_id) ? "block" : "none";
      });
    }
  }
}

function changePrice(selectedVariant, variantNewPrice, variantCent, variantOldPrice, percentOff, $afterpay, $priceDiff) {
  let globalProductVariantPrice = 0;
  let globalProductOldPrice = 0;

  // Main Price
  if ((selectedVariant.price / 100) % 1 === 0) {
    globalProductVariantPrice = (selectedVariant.price / 100).toFixed(0);
    if (variantNewPrice) variantNewPrice.innerHTML = globalProductVariantPrice;
    if (variantCent) variantCent.style.display = 'none';
  } else {
    globalProductVariantPrice = (selectedVariant.price / 100).toFixed(2);
    if (variantCent) {
      variantCent.style.display = 'block';
      variantCent.innerHTML = '.' + globalProductVariantPrice.split('.')[1];
    }
    if (variantNewPrice) {
      variantNewPrice.innerHTML = globalProductVariantPrice.split('.')[0];
    }
  }

  // Compare-At Price
  if (selectedVariant.compare_at_price > 0) {
    globalProductOldPrice = (selectedVariant.compare_at_price / 100).toFixed((selectedVariant.compare_at_price / 100) % 1 === 0 ? 0 : 2);
    if (variantOldPrice) variantOldPrice.innerHTML = '$' + globalProductOldPrice;
  } else {
    globalProductOldPrice = globalProductVariantPrice;
  }

  // Savings
  if ($priceDiff && parseFloat(globalProductOldPrice) > parseFloat(globalProductVariantPrice)) {
    $priceDiff.innerHTML = '$' + twoDigitDecimals((globalProductOldPrice * 100) - (globalProductVariantPrice * 100));
  }

  // Percentage Off
  if (percentOff.length > 0 && selectedVariant.compare_at_price > selectedVariant.price) {
    const getpercentOff = ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100;
    const percentInt = getpercentOff.toString().split('.')[0];
    
    percentOff.forEach(el => { if (el) el.innerHTML = percentInt; });
    
    const topPercentOff = document.querySelector('.product_displaytag .toppercentoff .js-percent-off');
    if (topPercentOff) topPercentOff.innerHTML = percentInt;
  }

  // Afterpay
  if ($afterpay) {
    $afterpay.innerHTML = '$' + (selectedVariant.price / 400).toFixed(2);
  }

  // Confirmation Title
  const confirmationTitle = document.querySelector('.please_select_size .customerSelectedSize');
  if (confirmationTitle) confirmationTitle.innerHTML = selectedVariant.title;

  // Broadcast price change event for other components to hook into safely
  document.dispatchEvent(new CustomEvent('variantPriceChanged', { detail: selectedVariant }));
}

function twoDigitDecimals(num) {
  return ((num / 100) % 1 === 0) ? (num / 100).toFixed(0) : (num / 100).toFixed(2);
}

function addCommas(num) {
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join('.');
}

function updateExtraDiscountBox(selectedVariant) {
  const discountBox = document.querySelector('.klv-extra-discount-box');
  if (!discountBox) return;

  const discountString = discountBox.getAttribute('data-active-discount');
  const priceSpan = discountBox.querySelector('.js-extra-discount-price');

  // A text-only flash has neither, because there is no number in it to recalculate.
  // Leave it exactly as Liquid rendered it.
  if (!discountString || !priceSpan) return;

  let currentPriceCents = selectedVariant.price;
  let finalPriceCents = currentPriceCents;

  // Calculate new price based on the metafield rule
  if (discountString.includes('%')) {
    let percentVal = parseFloat(discountString.replace('%', ''));
    if (!isNaN(percentVal)) {
      let discountAmount = currentPriceCents * (percentVal / 100);
      finalPriceCents = currentPriceCents - discountAmount;
    }
  } else if (discountString.includes('$')) {
    let dollarVal = parseFloat(discountString.replace('$', '')) * 100; // Multiply by 100 for cents
    if (!isNaN(dollarVal)) {
      finalPriceCents = currentPriceCents - dollarVal;
    }
  }

  // Prevent negative pricing
  if (finalPriceCents < 0) {
    finalPriceCents = 0;
  }

  // Format the output utilizing your existing helper functions
  const formattedString = addCommas(twoDigitDecimals(finalPriceCents));
  const isLegacyStyle = discountBox.classList.contains('klv-extra-discount-box--legacy');
  priceSpan.textContent = isLegacyStyle ? `Pay ONLY $${formattedString}` : formattedString;

  const accessiblePrice = discountBox.querySelector('.klv-discount-price, .klv-discount-top-row');
  if (accessiblePrice) {
    accessiblePrice.setAttribute('aria-label', `Discounted price $${formattedString}`);
  }
}

function openProductReview() {
  const targetDiv = document.querySelector('.newbottomreview');
  if (targetDiv) {
    setTimeout(() => {
      targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }
}

function zoom(e) {
  if (window.innerWidth <= 992) return;
  const zoomer = e.currentTarget;
  let offsetX, offsetY;

  if (e.type === 'touchmove') {
    offsetX = e.touches[0].pageX;
    offsetY = e.touches[0].pageY;
  } else {
    const rect = zoomer.getBoundingClientRect();
    offsetX = e.offsetX || e.clientX - rect.left;
    offsetY = e.offsetY || e.clientY - rect.top;
  }

  const x = (offsetX / zoomer.offsetWidth) * 100;
  const y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = `${x}% ${y}%`;
}

// 4. Core Variant Logic
function handleVariantChange() {
  const selectedValues = [];
  const selectedOptions = {};
  const clickedElement = this;

  // Visual active state update
  if (clickedElement?.tagName?.toLowerCase() === 'input' && clickedElement.type === 'radio') {
    const posRelative = clickedElement.closest('.pos_relative');
    clickedElement.closest('.radio-option').querySelectorAll('label').forEach(lbl => lbl.classList.remove('active'));
    if (posRelative) posRelative.querySelector('label')?.classList.add('active');
  }

  // Gather current values
  variantRadioButtons.forEach(radio => {
    if (radio.checked) selectedOptions[radio.dataset.optionName || radio.name] = radio.value;
  });
  variantSelects.forEach((select, index) => {
    selectedOptions[select.name || productOptions[index]] = select.value;
  });

  // Auto-correction for out of stock combinations
  const currentValuesArray = productOptions.map(opt => selectedOptions[opt]);
  const currentVariant = findSelectedVariant(productVariants, currentValuesArray);

  if (!currentVariant || (currentVariant.inventory_quantity <= 0 && currentVariant.inventory_policy === 'deny')) {
    const clickedOptionName = clickedElement?.dataset?.optionName || clickedElement?.name || null;

    productOptions.forEach(optName => {
      if (optName !== clickedOptionName) {
        const availableVariant = productVariants.find(v => {
          const matchesClicked = !clickedOptionName || v[`option${productOptions.indexOf(clickedOptionName) + 1}`] === selectedOptions[clickedOptionName];
          return matchesClicked && (v.inventory_quantity > 0 || v.inventory_policy !== 'deny');
        });

        if (availableVariant) {
          const optIndex = productOptions.indexOf(optName);
          const newOptValue = availableVariant[`option${optIndex + 1}`];
          selectedOptions[optName] = newOptValue;

          const targetRadio = Array.from(variantRadioButtons).find(r => (r.dataset.optionName || r.name) === optName && r.value === newOptValue);
          if (targetRadio) {
            variantRadioButtons.forEach(r => {
              if ((r.dataset.optionName || r.name) === optName) {
                r.checked = false;
                r.closest('.pos_relative')?.querySelector('label')?.classList.remove('active');
              }
            });
            targetRadio.checked = true;
            targetRadio.closest('.pos_relative')?.querySelector('label')?.classList.add('active');
          }
        }
      }
    });
  }

  // Evaluate final availability
  variantRadioButtons.forEach(radio => {
    const optionName = radio.dataset.optionName || radio.name;
    const testOptions = { ...selectedOptions, [optionName]: radio.value };
    const testVariant = findSelectedVariant(productVariants, productOptions.map(opt => testOptions[opt]));
    const label = radio.closest('.pos_relative')?.querySelector('label');
    const isFirstOption = (optionName === productOptions[0]);

    if (!testVariant || (testVariant.inventory_quantity <= 0 && testVariant.inventory_policy === 'deny')) {
      if (label) label.classList.add('outofstock');
    } else {
      if (label) label.classList.remove('outofstock');
      radio.disabled = false;
    }
  });

  // Update DOM
  productOptions.forEach(opt => {
    if (selectedOptions[opt]) selectedValues.push(selectedOptions[opt]);
  });

  const selectedVariant = findSelectedVariant(productVariants, selectedValues);
  if (selectedVariant) {
    if (!cachedUI.initialized) {
      cachedUI.form = clickedElement.closest ? (clickedElement.closest(".globalatc") || document.querySelector(".globalatc")) : document.querySelector(".globalatc");
      cachedUI.hiddenInput = cachedUI.form ? cachedUI.form.querySelector("input.hiddenform") : document.querySelector("input.hiddenform");
      cachedUI.quantityInput = document.querySelector(".product-form__buttons input.quntityInput");
      cachedUI.newPrice = cachedUI.form?.querySelector(".price_diff .formattedMainPrice");
      cachedUI.centPrice = cachedUI.form?.querySelector(".price_diff .formattedCentsPrice");
      cachedUI.oldPrice = cachedUI.form?.querySelector("span.js-old-price");
      cachedUI.percentOff = cachedUI.form ? cachedUI.form.querySelectorAll(".js-percent-off") : [];
      cachedUI.addButton = document.querySelector(".product-form__buttons button.addToCartBtn") || document.querySelector(".add-to-cart-gift-form");
      cachedUI.afterpay = cachedUI.form?.querySelector("span.js-afterpay-payments");
      cachedUI.priceDiff = cachedUI.form?.querySelector("span.js-save");
      cachedUI.colorName = cachedUI.form?.querySelector('.js-color-name');
      cachedUI.initialized = true;
    }
    
    const $addButtonStatus = selectedVariant.inventory_quantity > 0 || selectedVariant.inventory_policy !== 'deny';

    addToCartButton(cachedUI.addButton, $addButtonStatus, selectedVariant);
    updateURL(selectedVariant);
    if (cachedUI.hiddenInput) updateHiddenInput(selectedVariant, cachedUI.hiddenInput);
    if (cachedUI.quantityInput) setQuantityInputValue(selectedVariant, cachedUI.quantityInput);
    
    changePrice(selectedVariant, cachedUI.newPrice, cachedUI.centPrice, cachedUI.oldPrice, cachedUI.percentOff, cachedUI.afterpay, cachedUI.priceDiff);
    hideCompareAtPriceElement(selectedVariant);
    updateMedia(selectedVariant);
    
    updateExtraDiscountBox(selectedVariant);

    if (cachedUI.colorName && productOptions) {
      const colorIndex = productOptions.findIndex(opt => opt.toLowerCase().includes('colour') || opt.toLowerCase().includes('color'));
      if (colorIndex !== -1 && selectedVariant[`option${colorIndex + 1}`]) {
        cachedUI.colorName.textContent = selectedVariant[`option${colorIndex + 1}`];
      }
    }
  }
}

// 5. AJAX Cart Handling Object
const ajaxify = {
  onAddToCart: function(event) {
    event.preventDefault();
    if (this.classList.contains('yes')) {
      const pleaseSelect = this.closest('.please_select_size');
      if (pleaseSelect) pleaseSelect.style.display = 'none';
      
      const mainAtcBtn = document.querySelector('.add-to-cart button.addToCartBtn');
      if (mainAtcBtn) {
        mainAtcBtn.classList.remove('js-disabled-add-to-cart');
        mainAtcBtn.click();
        setTimeout(() => mainAtcBtn.classList.add('js-disabled-add-to-cart'), 400);
      }
    }
  },

  init: function() {
    const confirmYes = document.querySelector('.confirm_select_size button.yes');
    if (confirmYes) confirmYes.addEventListener('click', ajaxify.onAddToCart);
  }
};

// 6. Main DOM Initialization
document.addEventListener('DOMContentLoaded', () => {

  // Event Listeners for Variants
  variantRadioButtons.forEach(radio => radio.addEventListener('click', handleVariantChange));
  variantSelects.forEach(select => select.addEventListener('change', handleVariantChange));

  // Gift Form AJAX Cart
  const giftForm = document.querySelector('.product_mainform');
  const giftSubmitButton = giftForm?.querySelector('.add-to-cart-gift-form');

  if (giftForm && giftSubmitButton) {
    giftForm.addEventListener('submit', (e) => {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(giftForm),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(res => res.json())
      .then(sections => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.renderContents) {
          cartDrawer.renderContents({ id: Date.now(), sections: sections });
          setTimeout(() => {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
            const emptyMessage = cartDrawer.querySelector('.drawer__inner-empty');
            if (emptyMessage) emptyMessage.style.display = 'none';
            cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
            cartDrawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
          }, 50);
        }
      })
      .catch(err => console.error('Error handling cart drawer update:', err));
    });
  }

  // Quantity Picker
  const input = document.querySelector('.quantity-selector input.quantity__input');
  document.querySelectorAll('.quantity-selector span.quantitybutton').forEach(qp => {
    qp.addEventListener('click', function(e) {
      e.preventDefault();
      if (!input) return;
      let currentVal = parseInt(input.value);
      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || 999;

      if (this.classList.contains("quantity_minus")) {
        if (currentVal > min) input.value = currentVal - 1;
        this.disabled = (parseInt(input.value) <= min);
        this.closest('.quantity-selector').querySelector('.quantity_plus').removeAttribute("disabled");
      } else if (this.classList.contains("quantity_plus")) {
        if (currentVal < max) input.value = currentVal + 1;
        this.disabled = (parseInt(input.value) >= max);
        this.closest('.quantity-selector').querySelector('.quantity_minus').removeAttribute("disabled");
      }
    });
  });

  // Add To Cart Button Loading
  const productATCBtn = document.querySelector('.product-action .add_btn');
  if (productATCBtn) {
    productATCBtn.addEventListener('click', function() {
      const loadingButtonEl = this.querySelector('.custom-loading');
      if (loadingButtonEl) loadingButtonEl.classList.remove('hidden');
      fetch('/cart.js').then(() => {
        setTimeout(() => { if (loadingButtonEl) loadingButtonEl.classList.add('hidden'); }, 600);
      });
    });
  }

  // Reviews Jump
  document.querySelectorAll('.jumpsection a.mainproductreviews').forEach(element => {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      const isCompact = this.closest('body').classList.contains('compact');
      if (isCompact) {
        document.querySelector('body.compact .product_dropdown h2#title-r')?.closest('.content_block')?.classList.add('active');
      } else {
        document.querySelector('.product_dropdown .titles .title.review')?.click();
      }
      openProductReview();
    });
  });

  // Load the product lightbox only when a customer asks to open it.
  let productLightboxPromise;
  function loadProductLightbox() {
    if (typeof window.FsLightbox === 'function') return Promise.resolve();
    if (productLightboxPromise) return productLightboxPromise;

    const gallery = document.querySelector('[data-lightbox-script-url]');
    const scriptUrl = gallery?.dataset.lightboxScriptUrl;
    if (!scriptUrl) return Promise.reject(new Error('Product lightbox URL is unavailable.'));

    productLightboxPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error('Product lightbox failed to load.'));
      document.head.appendChild(script);
    });

    return productLightboxPromise;
  }

  // Restore Click-to-Popup Zoom
  const productZoomIcon = document.querySelector('.customimagezoom');
  if (productZoomIcon) {
    productZoomIcon.addEventListener('click', function(e) {
      e.preventDefault();
      // Look for the lightbox link inside the active slide
      const activeSlide = document.querySelector('.product__image-slider .is-selected') || document.querySelector('.img_producto_container');
      const activeZoomLink = activeSlide?.querySelector('a.fslightbox');
      
      if (!activeZoomLink) {
        console.warn("Zoom icon clicked, but no fslightbox link was found.");
        return;
      }

      loadProductLightbox()
        .then(() => activeZoomLink.click())
        .catch((error) => {
          console.warn(error);
          window.open(activeZoomLink.href, '_blank', 'noopener');
        });
    });
  }

  // Image Zoom
  document.querySelectorAll('.img_producto_container').forEach(container => {
    const imgUrl = container.getAttribute('data-img');
    const zoomImg = container.querySelector('img.zoomimg');
    let ticking = false;

    if (imgUrl) {
      container.style.backgroundImage = `url(${imgUrl})`;
      container.addEventListener('mousemove', (e) => {
        if (!ticking) {
          const proxyEvent = {
            type: e.type,
            offsetX: e.offsetX,
            offsetY: e.offsetY,
            clientX: e.clientX,
            clientY: e.clientY,
            currentTarget: container
          };

          window.requestAnimationFrame(() => {
            zoom(proxyEvent);
            if (zoomImg) zoomImg.style.opacity = 0;
            ticking = false;
          });
          ticking = true;
        }
      });
      container.addEventListener('mouseleave', () => {
        if (zoomImg) zoomImg.style.opacity = 1;
      });
    }
  });

  // Product Description Tabs
  const titles = document.querySelectorAll('.product-description-tab .title');
  const texts = document.querySelectorAll('.text');
  titles.forEach(title => {
    title.addEventListener('click', function() {
      if (this.classList.contains('help')) return;
      const id = this.id.split('-')[1];
      texts.forEach(text => text.style.display = (text.id === `text-${id}`) ? 'block' : 'none');
      titles.forEach(t => t.classList.remove('title-active'));
      this.classList.add('title-active');
    });
  });

  // Append PF Description
  const pf = document.querySelector('#__pf');
  const productBottom = document.querySelector('.product-description-tab .product-description');
  if (pf && productBottom) productBottom.appendChild(pf);

  // Confirmation Messages
  document.querySelectorAll("button.js-disabled-add-to-cart").forEach(button => {
    button.addEventListener("click", function(event) {
      event.preventDefault();
      document.querySelectorAll('.add_btn button.js-add-to-cart-button').forEach(btn => btn.style.color = 'white');
      const displaySelectMsg = document.querySelector('.please_select_size');
      if (displaySelectMsg) displaySelectMsg.style.display = 'block';
    });
  });

  const confirmNoBtn = document.querySelector('.confirm_select_size button.no');
  if (confirmNoBtn) {
    confirmNoBtn.addEventListener("click", function(e) {
      e.preventDefault();
      const parent = this.closest('.please_select_size');
      if (parent) parent.style.display = 'none';
    });
  }

  // Init Ajaxify
  ajaxify.init();
});
